import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaHandsHelping,
} from "react-icons/fa";

import "./Footer.css";
import logo from "../../Assest/HDSILOGO.jpg"; 

const Footer = () => {
  return (
    <>
      {/* ================= CTA SECTION ================= */}
      <section className="footer-cta">
        <div className="footer-container footer-cta-content">

          <div className="footer-cta-left">
            <div className="footer-heart">
              <FaHandsHelping />
            </div>

            <div>
              <h2>Be the Difference. Volunteer Today!</h2>

              <p>
                Together, we can create a more equitable, sustainable and
                compassionate world.
              </p>
            </div>
          </div>

          <div className="footer-cta-buttons">
           <a
  href="https://docs.google.com/forms/d/e/1FAIpQLSchtRgHB_XmFj3VqO-6NTaQzKsYjp0W_6Se-6Rc9Ep1I14lyQ/viewform"
  className="footer-btn footer-btn-primary"
>
  Join as a Volunteer →
</a>

            <Link to="/contact" className="footer-btn footer-btn-outline">
              Contact Us
            </Link>
          </div>

        </div>
      </section>

      {/* ================= MAIN FOOTER ================= */}

      <footer className="footer">

        <div className="footer-container footer-grid">

          {/* Logo */}

          <div className="footer-column">

            <img
              src={logo}
              alt="HDSI"
              className="footer-logo"
            />

            <p>
              Working for sustainable development and empowering rural
              communities for a better tomorrow.
            </p>

            <div className="footer-social">

              <button type="button" className="footer-social-btn" aria-label="Facebook"><FaFacebookF /></button>

              <a href="https://www.instagram.com/hdsi_official?igsh=MXRseWxiemw2cHowOA==" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>

              <button type="button" className="footer-social-btn" aria-label="YouTube"><FaYoutube /></button>

              <a href="https://www.linkedin.com/company/human-development-society-of-india/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>

            </div>

          </div>

          {/* Quick Links */}

          <div className="footer-column">

            <h4>Quick Links</h4>

            <Link to="/">Home</Link>

            <Link to="/about">About Us</Link>

            <Link to="/projects">Our Work</Link>

            {/* <Link to="/get-involved">Get Involved</Link> */}

            {/* <Link to="/resources">Resources</Link> */}

            <Link to="/gallery">Gallery</Link>

            <Link to="/contact">Contact Us</Link>

          </div>

          {/* Programs */}

          <div className="footer-column">

            <h4>Our Programs</h4>

            <Link to="/projects">Education</Link>

            <Link to="/projects">Women Empowerment</Link>

            <Link to="/projects">Water & Sanitation</Link>

            <Link to="/projects">Environment</Link>

            <Link to="/projects">Health & Livelihood</Link>

            <Link to="/projects">Community Care</Link>

          </div>

          {/* Get Involved */}

          <div className="footer-column">

            <h4>Get Involved</h4>

            <Link to="/donate">Donate</Link>



            <Link to="/partner">Partner With Us</Link>

            <Link to="/careers">Careers</Link>

          </div>

          {/* Contact */}

          <div className="footer-column">

  <h4>Contact Us</h4>

  {/* Address */}
  <a
    href="https://www.google.com/maps/search/?api=1&query=HDSI,+1st+Floor,+Yashoda+Niwas,+FC+Road,+Pune,+411004"
    target="_blank"
    rel="noopener noreferrer"
    className="footer-contact-link"
  >
    <FaMapMarkerAlt className="footer-icon" />
  642, HDSI, Plot 8,9 Chikhaldara Road , Dhotarkheda , Dist. Amravati, Tq. Achalpur, 444806 (MH) India 
  </a>

  {/* Phone */}
  <a
    href="tel:+918767002290"
    className="footer-contact-link"
  >
    <FaPhoneAlt className="footer-icon" />
    +91 87670 02290
  </a>

  {/* Email */}
  <a
    href="mailto:hdsi08@gmail.com"
    className="footer-contact-link"
  >
    <FaEnvelope className="footer-icon" />
    hdsi08@gmail.com
  </a>

</div>

        </div>

        {/* Bottom Footer */}

        <div className="footer-bottom">

          <div className="footer-container footer-bottom-content">

            <p>
              © {new Date().getFullYear()} Human Development Society of India. All Rights Reserved.
            </p>

            <div>

              <Link to="/privacy">
                Privacy Policy
              </Link>

              <span>|</span>

              <Link to="/terms">
                Terms & Conditions
              </Link>

              <span>|</span>

              <span className="footer-version">
                 Version 1.0.3
              </span>

            </div>

          </div>

        </div>

      </footer>
    </>
  );
};

export default Footer;